
<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="投诉内容">
                <a-input v-model="queryParam.name" placeholder="请输入" allow-clear @keyup.enter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择">
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dc:0:c']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dr:0:r']"
        >
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['1487ee3d6061b09f9337adea3a220a4de:0:e']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleCreateFormOk" />
      <create-form ref="innerCreateForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleInnerFormOk" />
      <create-form ref="grandCreateForm" :statusOptions="dict.type['sys_enable_disable']" @ok="handleGrandFormOk" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        @expand="onExpand"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag color="green" v-if="record.status == 1">启用</a-tag>
          <a-tag color="red" v-if="record.status == 0">禁用</a-tag>
        </span>
        <span slot="parentId" slot-scope="text, record">
          <a-tag color="green" v-if="record.parentId == 0">一层</a-tag>
          <a-tag color="orange" v-if="record.parentId == 1">二层</a-tag>
          <a-tag color="red" v-if="record.parentId == 2">三层</a-tag>
        </span>
        <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              style="width: 50px; height: 50px"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <a
            @click="$refs.createForm.handleUpdate(record, undefined)"
            v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d']"
          >修改</a
          >
          <a-divider
            type="vertical"
            v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d', '1487ee3d6061b09f9337adea3a220a4dd:0:d']"
          />
          <a-dropdown v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d', '1487ee3d6061b09f9337adea3a220a4dd:0:d']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"><a-icon type="double-right" />更多</a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dc:0:c']">
                <a
                  @click="$refs.createForm.handleAdd(record)"
                  v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dc:0:c']"
                >添加</a
                >
              </a-menu-item>
              <a-menu-item v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dr:0:r']">
                <a @click="handleDelete(record)" v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dr:0:r']">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          rowKey="id"
          :size="tableSize"
          :columns="innerColumns"
          :data-source="innerData[record.id] || []"
          :loading="innerLoading[record.id]"
          :pagination="innerPaginationVisible[record.id] ? innerPagination[record.id] : false"
          :row-selection="{
            selectedRowKeys: innerSelectedRowKeys[record.id] || [],
            onChange: (keys, rows) => onInnerSelectChange(keys, rows, record.id),
          }"
          :bordered="tableBordered"
          @expand="onInnerExpand"
        >
          <span slot="status" slot-scope="text, subRow">
            <a-tag color="green" v-if="subRow.status == 1">启用</a-tag>
            <a-tag color="red" v-if="subRow.status == 0">禁用</a-tag>
          </span>
          <span slot="parentId" slot-scope="text, subRow">
            <a-tag color="orange">二层</a-tag>
          </span>
          <div slot="pic" slot-scope="text, subRow">
            <div v-viewer>
              <img
                :src="$url + subRow.pic"
                style="width: 50px; height: 50px"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </div>
          <span slot="operation" slot-scope="text, subRow">
            <a
              @click="$refs.innerCreateForm.handleUpdate(subRow, undefined)"
              v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d']"
            >修改</a
            >
            <a-divider
              type="vertical"
              v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d', '1487ee3d6061b09f9337adea3a220a4dd:0:d']"
            />
            <a-dropdown v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dd:0:d', '1487ee3d6061b09f9337adea3a220a4dd:0:d']">
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()"><a-icon type="double-right" />更多</a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="$refs.grandCreateForm.handleAdd(subRow)">新增</a>
                </a-menu-item>
                <a-menu-item v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dr:0:r']">
                  <a
                    @click="handleDelete(subRow, 'inner')"
                    v-hasPermi="['1487ee3d6061b09f9337adea3a220a4dr:0:r']"
                  >删除</a
                  >
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>

          <a-table
            slot="expandedRowRender"
            slot-scope="subRecord"
            rowKey="id"
            :size="tableSize"
            :columns="grandColumns"
            :data-source="grandData[subRecord.id] || []"
            :loading="grandLoading[subRecord.id]"
            :pagination="grandPagination[subRecord.id] || false"
            :row-selection="{
              selectedRowKeys: grandSelectedRowKeys[subRecord.id] || [],
              onChange: (keys, rows) => onGrandSelectChange(keys, rows, subRecord.id),
            }"
            :bordered="tableBordered"
            @change="(p) => handleGrandPageChange(p, subRecord)"
          >
            <span slot="status" slot-scope="text, gRow">
              <a-tag color="green" v-if="gRow.status == 1">正常</a-tag>
              <a-tag color="red" v-if="gRow.status == 0">下线</a-tag>
            </span>
            <span slot="parentId" slot-scope="text, gRow">
              <a-tag color="red">三层</a-tag>
            </span>
            <div slot="pic" slot-scope="text, gRow">
              <div v-viewer>
                <img
                  :src="$url + gRow.pic"
                  style="width: 60px; height: 60px; object-fit: contain"
                  @error="(e) => (e.target.src = errorImage)"
                />
              </div>
            </div>
            <div slot="icon" slot-scope="text, gRow">
              <div v-viewer>
                <img
                  :src="$url + gRow.icon"
                  style="width: 60px; height: 60px; object-fit: contain"
                  @error="(e) => (e.target.src = errorImage)"
                />
              </div>
            </div>
            <span slot="operation" slot-scope="text, gRow">
              <span :class="getOpCls(gRow)">
                <a @click="$refs.grandCreateForm.handleUpdate(gRow, undefined, 'grand')">修改</a>
                <a-divider type="vertical" />
                <a-dropdown>
                  <a class="ant-dropdown-link">更多<a-icon type="double-right" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item><a @click="handleDelete(gRow, 'grand')">删除</a></a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </span>
          </a-table>
        </a-table>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/maintenance/repairSort/index.js'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Post',
  components: { CreateForm },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      innerSelectedRowKeys: {},
      grandSelectedRowKeys: {},
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      errorImage: require('/src/assets/images/defaultImg.png'),
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        parentId: '0',
        status: undefined,
      },
      innerColumns: [
        { title: '投诉内容', dataIndex: 'name', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      grandColumns: [
        { title: '投诉内容', dataIndex: 'name', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      columns: [
        { title: '投诉内容', dataIndex: 'name', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      innerData: {},
      innerLoading: {},
      innerPagination: {},
      innerPaginationVisible: {},
      grandData: {},
      grandLoading: {},
      grandPagination: {},
      currentParentId: null,
      currentGrandParentId: null,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10, name: undefined, parentId: '0', status: undefined }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    onInnerSelectChange(keys, rows, pid) {
      this.$set(this.innerSelectedRowKeys, pid, keys)
    },
    onGrandSelectChange(keys, rows, pid) {
      this.$set(this.grandSelectedRowKeys, pid, keys)
    },
    handleAdd() {
      this.$refs.createForm.handleAdd()
    },
    handleUpdate() {
      const id = this.selectedRowKeys[0]
      this.$refs.createForm.handleUpdate({ id })
    },
    handleDelete(row, level = 'main') {
      const ids = row.id ? [row.id] : this.selectedRowKeys
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk: () =>
          delObj(ids.map((id) => ({ id }))).then(() => {
            this.$message.success('删除成功', 3)

            if (level === 'main') {
              this.onSelectChange([], [])
              this.getList()
            } else if (level === 'inner') {
              this.loadInner(
                { id: this.currentParentId },
                this.innerPagination[this.currentParentId]?.current || 1,
                this.innerPagination[this.currentParentId]?.pageSize || 5
              )
            } else if (level === 'grand') {
              this.loadGrand(
                { id: this.currentGrandParentId },
                this.grandPagination[this.currentGrandParentId]?.current || 1,
                this.grandPagination[this.currentGrandParentId]?.pageSize || 5
              )
            }
          }),
      })
    },
    handleExport() {
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk: () =>
          this.download(
            'upkeep/complaint/export',
            { ...this.queryParam },
            `维修投诉分类信息_${new Date().getTime()}.xlsx`
          ),
      })
    },
    handleCreateFormOk() {
      this.getList()
    },
    handleInnerFormOk() {
      if (!this.currentParentId || !this.innerPagination[this.currentParentId]) {
        this.getList()
        return
      }
      this.loadInner(
        { id: this.currentParentId },
        this.innerPagination[this.currentParentId].current,
        this.innerPagination[this.currentParentId].pageSize
      )
    },
    handleGrandFormOk() {
      if (!this.currentGrandParentId || !this.grandPagination[this.currentGrandParentId]) {
        this.getList()
        return
      }
      this.loadGrand(
        { id: this.currentGrandParentId },
        this.grandPagination[this.currentGrandParentId].current,
        this.grandPagination[this.currentGrandParentId].pageSize
      )
    },
    onExpand(expanded, record) {
      if (!expanded) return
      this.currentParentId = record.id
      this.$set(this.innerPagination, record.id, {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      })
      this.$set(this.innerPaginationVisible, record.id, true)
      this.loadInner(record)
    },
    loadInner(record, page = 1, size = 5) {
      this.$set(this.innerLoading, record.id, true)
      fetchList({ pageNum: page, pageSize: size, parentId: record.id }).then((res) => {
        this.$set(this.innerData, record.id, res.data.records)
        const pager = this.innerPagination[record.id]
        pager.total = res.data.total
        pager.current = page
        pager.pageSize = size
        this.$set(this.innerLoading, record.id, false)
      })
    },
    handleInnerPageChange(pagination, record) {
      this.loadInner(record, pagination.current, pagination.pageSize)
    },
    onInnerExpand(expanded, record) {
      if (!expanded) {
        this.$set(this.innerPaginationVisible, this.currentParentId, true)
        return
      }
      this.currentGrandParentId = record.id
      this.$set(this.innerPaginationVisible, this.currentParentId, false)
      this.$set(this.grandPagination, record.id, {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
      })
      this.loadGrand(record)
    },
    loadGrand(record, page = 1, size = 5) {
      this.$set(this.grandLoading, record.id, true)
      fetchList({ pageNum: page, pageSize: size, parentId: record.id }).then((res) => {
        this.$set(this.grandData, record.id, res.data.records)
        const pager = this.grandPagination[record.id]
        pager.total = res.data.total
        pager.current = page
        pager.pageSize = size
        this.$set(this.grandLoading, record.id, false)
      })
    },
    handleGrandPageChange(pagination, record) {
      this.loadGrand(record, pagination.current, pagination.pageSize)
    },
    getOpCls(record) {
      return this.selectedRowKeys.includes(record.id) ? 'op-highlight' : ''
    },
  },
}
</script>

<style scoped>
.ant-table-thead > tr > th {
  background-color: #303133;
  color: #fff;
  font-weight: 600;
}
.ant-table-tbody > tr:nth-child(even) {
  background-color: #fafafa;
}
.ant-table-tbody > tr:nth-child(odd) {
  background-color: #ffffff;
}
.op-highlight {
  color: #1890ff;
  font-weight: bold;
}
</style>
